import React from 'react';
import './WaveformLoaderVendors.css';

export const WaveformLoaderVendors = ({
     isLoading,
     darkMode,
     width,
     height,
     marginTop,
     marginBottom,
     marginLeft,
     marginRight
                               }) => {
  return isLoading ? (
    <div
      className={darkMode ? "waveform-loader-dark" : "waveform-loader"}
      style={{
        width,
        height,
        marginTop,
        marginBottom,
        marginLeft,
        marginRight
      }}
    ></div>
  ) : null;
};
